'use client';

import { Badge } from '@highlight-cp/core-ui';
import type { BadgeProps } from '@highlight-cp/core-ui';

export type NewBadgeProps = Omit<
  BadgeProps,
  | 'bg'
  | 'children'
  | 'color'
  | 'fullWidth'
  | 'leftSection'
  | 'rightSection'
  | 'radius'
  | 'size'
  | 'variant'
>;

/**
 * ### NewBadge
 *
 * @description
 * A "NEW" badge for a freshly launched feature, such as Pulse's top nav item and home page card.
 * A client component so a Server Component, such as the portal layout, can render it without
 * pulling the badge's UI into the server graph.
 *
 * @example
 * <NewBadge />
 *
 * @returns React component
 */
export const NewBadge = (props: NewBadgeProps) => (
  <Badge {...props} color="primary" radius="xl" size="sm" variant="filled">
    NEW
  </Badge>
);
